module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      paddingTop: _vm.height169 + 50 + 'px'
    })
  }, [_c('app-view', {
    attrs: {
      "custom": true
    },
    on: {
      "open": _vm.onOpen,
      "close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "fixedTop"
  }, [_c('div', {
    staticClass: "player",
    style: (_vm._f("bg")(_vm.item.thumb))
  }, [_c('img', {
    attrs: {
      "src": "static/169.png"
    }
  }), _vm._v(" "), (_vm.item.push_status == 1 || _vm.item.push_status == 3) ? _c('div', [_c('div', {
    staticClass: "video",
    attrs: {
      "id": "video"
    }
  }, [_c('video', {
    attrs: {
      "poster": _vm.videoPoster,
      "src": _vm.videoUrl,
      "x5-playsinline": "",
      "x-webkit-airplay": "",
      "webkit-playsinline": "",
      "playsinline": "",
      "controls": "",
      "controlslist": "nodownload noremoteplayback noplaybackrate",
      "disablePictureInPicture": true
    }
  })])]) : _c('div', {
    staticClass: "mask"
  }, [(_vm.item.push_status == 0) ? _c('div', [_c('div', [_vm._v("直播将于" + _vm._s(_vm._f("datetime")(_vm.item.starttime)) + "开始")]), _vm._v(" "), (_vm.leftTime >= 0) ? _c('div', [_vm._v(_vm._s(_vm._f("seconds")(_vm.leftTime)))]) : _vm._e()]) : (_vm.item.push_status == 2) ? _c('div', [_vm._v("直播已结束")]) : (_vm.item.push_status == 4) ? _c('div', [_vm._v("\n                        直播已结束\n                        "), _c('br'), _vm._v("您可以\n                        "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.onPlayerVideo(_vm.movid, _vm.urlid)
      }
    }
  }, [_vm._v("点击这里观看回放")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', [_c('i', {
    staticClass: "icon icon-zongrenshu"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("unit")(_vm.onlineCount)))])]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "icon icon-guankancishu"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("unit")(_vm.item.hits)))])]), _vm._v(" "), _c('label'), _vm._v(" "), _c('a', {
    class: {
      on: _vm.item.good
    },
    on: {
      "click": function($event) {
        return _vm.onVote(_vm.item)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-a-lujing133"
  }), _vm._v(" "), (_vm.item.good) ? _c('span', [_vm._v(_vm._s(_vm._f("unit")(_vm.item.agree)))]) : _c('span', [_vm._v("点赞")])]), _vm._v(" "), (_vm.item.donate_url) ? _c('a', {
    on: {
      "click": _vm.onShowSupport
    }
  }, [_c('i', {
    staticClass: "icon icon-a-Iconawesome-donate"
  }), _vm._v("参与\n                ")]) : _vm._e(), _vm._v(" "), (_vm.shareVisible) ? _c('a', {
    on: {
      "click": _vm.onShowShare
    }
  }, [_c('i', {
    staticClass: "icon icon-share"
  }), _vm._v("分享\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), (_vm.item.item_status == 0) ? _c('div', {
    staticClass: "html"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.content)
    }
  })]) : _c('div', {
    ref: "scroller",
    staticClass: "list"
  }, _vm._l((_vm.item.item_json), function(item, i) {
    return _c('div', {
      staticClass: "item",
      class: {
        on: i == _vm.timeIndex
      }
    }, [_c('span', [_vm._v(_vm._s(item.key))]), _vm._v(" "), _c('span', {
      staticClass: "line1"
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), (i == _vm.timeIndex) ? _c('i', {
      staticClass: "icon icon-play1"
    }) : _vm._e()])
  }), 0)]), _vm._v(" "), (_vm.item.ad && _vm.adVisible) ? _c('div', {
    staticClass: "ad"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.onOpenUrl(_vm.item.ad.linkurl)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.item.ad.image
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "close",
    on: {
      "click": _vm.onAdClosed
    }
  }, [_vm._v("关闭")])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f34c6c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/lives/Room.vue
// module id = 318
// module chunks = 0